module.exports = __webpack_public_path__ + "static/media/connection.4c252aff.svg";